module.exports = __webpack_public_path__ + "static/media/Medal.f07dc1f6.svg";